import * as fromOffer from './core/states/offer/offer.reducer';
import * as fromApp from './core/states/app/app.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { OfferState } from './core/states/offer/offer.state';
import { AppState } from './core/states/app/app.state';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

export interface SSCState {
  offer?: OfferState;
  app?: AppState;
  router: RouterReducerState;
}

export const reducers: ActionReducerMap<SSCState> = {
  offer: fromOffer.reducer,
  app: fromApp.reducer,
  router: routerReducer,
};
